import React from 'react';

const capabilities = [
  'User research & persona creation',
  'Wireframing and user flow mapping',
  'High-fidelity UI design using Figma',
  'Prototyping and interaction design',
  'Design systems & style guides',
  'Mobile-first and responsive design',
  'Usability testing & feedback integration',
  'Color theory and typography mastery',
  'Design consistency and pixel-perfect detail',
  'Component-based UI architecture (React)',
  'Version control using Git',
  'React.js, JavaScript, Tailwind CSS,',
  'Communication and documentation',
];

const CapacitiesSection: React.FC = () => {
  return (
    <section className="bg-[#f8f8f8] min-h-[70vh] flex items-center py-24 px-4 sm:px-8" data-bg="light">
      <div className="w-full max-w-7xl mx-auto flex flex-col md:flex-row md:items-start md:justify-between gap-12 md:gap-24">
        {/* Left: Heading and Subtitle */}
        <div className="md:w-2/3 flex flex-col items-start">
          <h1 className="text-5xl mb-2 text-black font-bold">Capabilities</h1>
          <p className="text-lg text-gray-600">Here's what I bring to the table</p>
        </div>
        {/* Right: Capabilities List */}
        <div className="md:w-3/4 flex flex-col items-start">
          <ul className="space-y-4 md:space-y-6 text-left w-full">
            {capabilities.map((cap) => (
              <li
                key={cap}
                className={`text-2xl md:text-[32px] text-black flex items-center cursor-pointer group transition-all duration-[600ms] ease-[cubic-bezier(0.77,0,0.175,1)] md:hover:-translate-x-[100px]`}
                style={{ lineHeight: 1.3 }}
              >
                <span className="group-hover:font-bold">{cap}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};

export default CapacitiesSection;